// src/Pages/Dashboard/Analytics/Analytics.jsx
import React from 'react';
import ReactECharts from 'echarts-for-react';
import '../../../../../../Stylesheets/Dashboard/Tabs/Analytics/Analytics.css'; // Style separately

const Analytics = () => {
  const dailyLogOption = {
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yAxis: { type: 'value' },
    series: [{
      data: [6, 6, 6, 8, 9, 7, 5],
      type: 'line',
      smooth: true,
      lineStyle: { color: '#5c9dff', width: 3 }
    }],
  };

  const expenseOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    series: [
      {
        type: 'pie',
        radius: '65%',
        data: [
          { value: 50, name: 'Labor' },
          { value: 20, name: 'Transport' },
          { value: 17, name: 'Materials' },
          { value: 13, name: 'Misc' }
        ],
        color: ['#ff5c5c', '#ffa940', '#ffe58f', '#fff7ae'],
      }
    ]
  };

  const materialOption = {
    tooltip: {},
    legend: { data: ['Used', 'Received'] },
    dataset: {
      source: [
        ['Material', 'Used', 'Received'],
        ['Cement', 80, 100],
        ['Bricks', 90, 120],
        ['Steel', 60, 100]
      ]
    },
    xAxis: { type: 'value' },
    yAxis: { type: 'category' },
    series: [
      { type: 'bar', encode: { x: 'Used', y: 'Material' }, itemStyle: { color: '#ff6f61' } },
      { type: 'bar', encode: { x: 'Received', y: 'Material' }, itemStyle: { color: '#e0e0e0' } }
    ]
  };


  const attendanceTrendsOption = {
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}%',
      }
    },
    series: [
      {
        data: [65, 82, 95, 85, 70, 55, 40],
        type: 'line',
        smooth: true,
        itemStyle: { color: '#ff5c5c' },
        lineStyle: { width: 3 },
        symbolSize: 10
      }
    ]
  };


  return (
    <div className="analytics-container">
      <div className="analytics-header-metrics">
        <div className="metric-box">
          <p className="metric-title">Material Usage</p>
          <h2 className="metric-value">85% <span>used</span></h2>
        </div>
        <div className="metric-box">
          <p className="metric-title">Total Expense</p>
          <h2 className="metric-value">₹85,500</h2>
        </div>
        <div className="metric-box">
          <p className="metric-title">Attendance Rate</p>
          <h2 className="metric-value">85% <span>this week</span></h2>
        </div>
        <div className="metric-box">
          <p className="metric-title">Project Progress</p>
          <div className="progress-row">
            <h2 className="metric-value">48%</h2>
            <div className="progress-bar-inline">
              <div className="progress-fill" style={{ width: '48%' }}></div>
            </div>
          </div>
        </div>


      </div>


      <div className="charts-grid">
        <div className="chart-box">
          <h3>Daily Log Activity</h3>
          <ReactECharts option={dailyLogOption} />
        </div>
        <div className="chart-box">
          <h3>Expense Breakdown</h3>
          <ReactECharts option={expenseOption} />
        </div>
        <div className="chart-box">
          <h3>Material Usage Tracker</h3>
          <ReactECharts option={materialOption} />
        </div>
      </div>


    



      <div className="bottom-grid">
        <div className="chart-box">
          <h3>Attendance Trends</h3>
          <ReactECharts option={attendanceTrendsOption} />
        </div>

        <div className="chart-box">
          <h3>Most Used Materials</h3>
          <table className="material-table">
            <thead>
              <tr>
                <th>Material</th>
                <th>Used</th>
                <th>Received</th>
                <th>% Used</th>
              </tr>
            </thead>
            <tbody>
              {[
                { name: 'Cement', used: 120, received: 150, percent: 80 },
                { name: 'Bricks', used: 500, received: 650, percent: 77 },
                { name: 'Steel', used: 90, received: 150, percent: 60 }
              ].map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.used}</td>
                  <td>{item.received}</td>
                  <td>
                    <span className="usage-pill">{item.percent}%</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>


      <div className="insights-grid">
        <div className="chart-box">
          <h3>Weekly Expense Trend</h3>
          <ReactECharts option={{
            xAxis: { type: 'category', data: ['Week 1', 'Week 2', 'Week 3', 'Week 4'] },
            yAxis: { type: 'value' },
            series: [{
              data: [45000, 52000, 61000, 58000],
              type: 'line',
              smooth: true,
              areaStyle: {},
              itemStyle: { color: '#fa541c' },
              lineStyle: { width: 3 }
            }]
          }} />
        </div>

        <div className="chart-box today-summary">
          <h3>Today’s Snapshot</h3>
          <ul>
            <li>📝 <strong>3</strong> Logs submitted</li>
            <li>👷 <strong>27</strong> Workers present</li>
            <li>💰 <strong>₹24,000</strong> spent today</li>
          </ul>
        </div>

        <div className="chart-box">
          <h3>Overused Materials</h3>
          <table className="material-table">
            <thead><tr><th>Material</th><th>% Used</th></tr></thead>
            <tbody>
              {[
                { name: 'Sand', percent: 110 },
                { name: 'Steel', percent: 105 }
              ].map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td><span className="usage-pill overused">{item.percent}%</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="chart-box">
          <h3>Top Expense Sources</h3>
          <ReactECharts option={{
            xAxis: {
              type: 'category',
              data: ['Labor', 'Cement', 'Transport', 'Equipment']
            },
            yAxis: { type: 'value' },
            series: [{
              data: [120000, 95000, 30000, 20000],
              type: 'bar',
              itemStyle: { color: '#ff7875' },
              barWidth: '50%'
            }]
          }} />
        </div>

        <div className="chart-box site-health-card">
          <h3>Site Health Score</h3>
          <div className="health-score">82/100</div>
          <p className="health-tip">Looking good — improve weekend logs.</p>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
